import { nullChecker, uppercaseFirstLetter } from "../utils";

export const columnsKematian = [
  {
    text: "NO",
    formatter: (cell, row, i) => i + 1,
  },
  {
    dataField: "penduduk.nama",
    text: "NAMA",
    formatter: (cell, row) => nullChecker(row?.penduduk.nama?.toUpperCase()),
  },
  {
    dataField: "tanggal_kematian",
    text: "TANGGAL KEMATIAN",
    formatter: nullChecker,
  },
  {
    dataField: "jam",
    text: "JAM",
    formatter: nullChecker,
  },
  {
    dataField: "sebab_kematian",
    text: "SEBAB KEMATIAN",
    formatter: (cell, row) =>
      nullChecker(uppercaseFirstLetter(row?.sebab_kematian)),
  },
  {
    dataField: "tempat_kematian",
    text: "TEMPAT KEMATIAN",
    formatter: (cell, row) =>
      nullChecker(uppercaseFirstLetter(row?.tempat_kematian)),
  },
  {
    dataField: "yang_menerangkan",
    text: "YANG MENERANGKAN",
    formatter: (cell, row) =>
      nullChecker(uppercaseFirstLetter(row?.yang_menerangkan)),
  },
  {
    dataField: "nama_pelapor",
    text: "NAMA PELAPOR",
    formatter: (cell, row) => nullChecker(row?.nama_pelapor),
  },
  {
    dataField: "nama_saksi_satu",
    text: "NAMA SAKSI 1",
    formatter: (cell, row) => nullChecker(row?.nama_saksi_satu),
  },
  {
    dataField: "nama_saksi_dua",
    text: "NAMA SAKSI 2",
    formatter: (cell, row) => nullChecker(row?.nama_saksi_dua),
  },
];

export const columnsKelahiran = [
  {
    text: "NO",
    formatter: (cell, row, i) => i + 1,
  },
  {
    dataField: "nama",
    text: "NAMA",
    formatter: (cell, row) => nullChecker(row?.nama?.toUpperCase()),
  },
  {
    dataField: "jenis_kelamin",
    text: "JENIS KELAMIN",
    formatter: (cell, row) =>
      nullChecker(uppercaseFirstLetter(row?.jenis_kelamin)),
  },
  {
    dataField: "tempat_dilahirkan",
    text: "TEMPAT DILAHIRKAN",
    formatter: (cell, row) =>
      nullChecker(uppercaseFirstLetter(row?.tempat_dilahirkan)),
  },
  {
    dataField: "tempat_kelahiran",
    text: "TEMPAT KELAHIRAN",
    formatter: (cell, row) =>
      nullChecker(uppercaseFirstLetter(row?.tempat_kelahiran)),
  },
  {
    dataField: "tanggal_kelahiran",
    text: "TANGGAL KELAHIRAN",
    formatter: nullChecker,
  },
  {
    dataField: "jam",
    text: "JAM",
    formatter: nullChecker,
  },
  {
    dataField: "jenis_kelahiran",
    text: "JENIS KELAHIRAN",
    formatter: (cell, row) =>
      nullChecker(uppercaseFirstLetter(row?.jenis_kelahiran)),
  },
  {
    dataField: "kelahiran_ke",
    text: "KELAHIRAN KE",
    formatter: nullChecker,
  },
  {
    dataField: "penolong_kelahiran",
    text: "PENOLONG KELAHIRAN",
    formatter: (cell, row) =>
      nullChecker(uppercaseFirstLetter(row?.penolong_kelahiran)),
  },
  {
    dataField: "berat_bayi",
    text: "BERAT BAYI",
    formatter: nullChecker,
  },
  {
    dataField: "panjang_bayi",
    text: "PANJANG BAYI",
    formatter: nullChecker,
  },
  {
    dataField: "nama_ayah",
    text: "NAMA AYAH",
    formatter: (cell, row) => nullChecker(row?.nama_ayah?.toUpperCase()),
  },
  {
    dataField: "nama_ibu",
    text: "NAMA IBU",
    formatter: (cell, row) => nullChecker(row?.nama_ibu?.toUpperCase()),
  },
  {
    dataField: "nama_pelapor",
    text: "NAMA PELAPOR",
    formatter: (cell, row) => nullChecker(row?.nama_pelapor?.toUpperCase()),
  },
];
